export default __webpack_public_path__ + "static/media/black-cloud.91006790.svg";